<template>
  <div id="app">
    <Header/>
    <div class="main-template">
      <router-view class="view"/>
    </div>
    <Header :footer="true"/>
  </div>
</template>

<script>
import Header from "./components/shared/Header";

export default {
  components: {
    Header
  },
}
</script>

<style lang="scss">
#app {
  background: black;
}

.main-template {

  .view {
    width: 100%;
  }
}
</style>
